import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { TextFieldProps } from "@mui/material";
import dayjs, { Dayjs } from "dayjs";
import isoWeek from "dayjs/plugin/isoWeek";
import { useTranslation } from "react-i18next";

dayjs.extend(isoWeek);

type Props = {
  label: string;
  value: string; // formato 'YYYY-ww'
  onChange: (isoWeek: string) => void;
};

export default function WeekPicker({ label, value, onChange }: Props) {
  const { i18n } = useTranslation<"translation">();
  dayjs.locale(i18n.language); // respeta la localización actual

  const [year, week] = value.split("-").map(Number);

  // Calcula el lunes de la semana ISO seleccionada
  const selectedDate = dayjs(`${year}-01-04`)
    .startOf("isoWeek")
    .add(week - 1, "week");

  const handleChange = (date: Dayjs | null) => {
    if (!date) return;
    const iso = `${date.isoWeekYear()}-${String(date.isoWeek()).padStart(2, "0")}`;
    onChange(iso);
  };

  return (
    <DatePicker
      label={label}
      value={selectedDate}
      onChange={handleChange}
      format="ddd DD/MM/YYYY"
      views={["day"]}
      showDaysOutsideCurrentMonth // ← muestra días del mes adyacente
      shouldDisableDate={(d) => d.day() !== 1} // sólo lunes
      slotProps={{
        textField: { fullWidth: true } as Partial<TextFieldProps>,
      }}
    />
  );
}
